import $ from 'jquery';

// import CCAShareCheckbox from '@/components/form/CCAShareCheckbox.vue';

export default {
    name: 'ordonnance-medicale-modal',
    // components: { CCAShareCheckbox },
    props: {
        consultation_id: Number,
        user_id: Number,
        evolution_id: Number,
        modal_toggler: Number,
        selected_ordonnance: Object,
        data_to_be_deleted: Object,
        selected_prescription: Object,
        info_patient: Object,
        info_caissier: Object
    },
    data() {
        return {
            save_loading: false,
            value: '',
            filtered_medicaments: [],
            prescriptions: [{
                medicament_stock: null,
                medicament_libelle: "",
                interne: false,
                quantite: 1,
                posologie: "",
                conditionnement: "",
                prix: 0,
                quantite_stock: null
            }],

            fields: ['categorie', 'libelle', 'qte_disponible',],
            filter: "",
            perPage: 10,
            currentPage: 1,

            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,
            is_paid: false,
            patient_id: '',
            is_conflict: false,

            error_message: ''
        }
    },

    watch: {
        modal_toggler() {
            this.save_loading = false
            this.clearError()
            this.prescriptions = [{
                medicament_stock: null,
                medicament_libelle: "",
                interne: false,
                quantite: 1,
                posologie: "",
                conditionnement: "",
                prix: 0,

            }]
        }, 

        data_to_be_deleted() {
            this.clearError() 
        }
    },

    computed: {
        medicaments() {
            return this.$store.getters["medicaments"];
        },

        can_add_differential_computing() {
            return this.$store.getters["can_add_differential_computing"]
        },
    },

    mounted() {
        this.getListeMedicaments()
        this.patient_id = this.$route.params.id

        this.$store.dispatch('getDifferentialComputing')
    },

    methods: {
        getListeMedicaments() {
            this.$store.dispatch("getMedicaments")
        },

        filterMedicament() {
            this.filtered_medicaments = [];
            if (this.value.length > 2) {
                this.medicaments.forEach(
                    element => {
                        if (element.libelle.toLowerCase().includes(this.value.toLowerCase())) {
                            this.filtered_medicaments.push(element)
                        }
                    }
                )
            }
        },

        checkPrescriptionQuantite(prescription) {
            if (prescription.interne === true) {
                return prescription.quantite_stock
            } else {
                return 100000000000000000
            }

        },

        addInterneMedicament(index, medicament) {

            this.prescriptions[index].medicament_stock = medicament.id
            this.prescriptions[index].medicament_libelle = medicament.libelle
            this.prescriptions[index].prix = medicament.prix
            this.prescriptions[index].interne = true
            this.prescriptions[index].quantite_stock = medicament.qte_disponible


            this.value = ""
            this.filtered_medicaments = []

        },

        addExterneMedicament(index) {

            this.prescriptions[index].medicament_libelle = this.value
            this.prescriptions[index].interne = false

            this.value = ""
            this.filtered_medicaments = []

        },


        addPrescription() {
            this.prescriptions.push({
                "medicament_libelle": "",
                "medicament_stock": null,
                "quantite": 1,
                "posologie": "",
                "conditionnement": "",
                "indication": ""
            })
        },

        removePrescription(index) {
            this.prescriptions.splice(index, 1)

        },

        clearError() {
            this.permission_is_denied = false
            this.is_error = false
            this.is_paid = false
            $('.err-msg').fadeOut()
        },

        async submitOrdonnance() {
            this.clearError()
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return
            }

            let liste_prescriptions = []
            this.prescriptions.forEach(prescription => {
                const tmp_prescription = {
                    id: prescription.medicament_stock,
                    nom: prescription.medicament_libelle,
                    interne: prescription.interne,
                    qte: prescription.quantite,
                    posologie: prescription.posologie,
                    conditionnement: prescription.conditionnement,
                    prix: prescription.prix,
                }
                liste_prescriptions.push(tmp_prescription)
            });

            liste_prescriptions = this.setPrestationUID(liste_prescriptions)

            const data = {
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                ordonnance_id: this.selected_ordonnance.ordonnance_id,
                prescriptions: liste_prescriptions,
                user_id: this.user_id,
                patient_id: this.patient_id,
                type_prestation: 'Médicaments',
                can_set_pac: this.can_set_pac,
                info_patient: this.info_patient,
                info_caissier: this.info_caissier
            }

            this.save_loading = true
            this.$store.dispatch('saveConsultationOrdonnance', data).then((response) => {
                if (response.success) {
                    this.$refs.modal_ordonnance.click()
                    this.$emit("emitRefreshOrdonnance")

                    this.prescriptions = [{
                        medicament_stock: null,
                        medicament_libelle: "",
                        interne: false,
                        quantite: 1,
                        posologie: "",
                        conditionnement: "",
                        prix: 0,
                    }]
                } else {
                    if (response.code === 500) {
                        this.is_error = true
                    } else if (response === 403) {
                        this.permission_is_denied = true
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        /**
		 * Retirer un examen de la liste de demande
		 */
        deletePrescription(selector) {
            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            
            this.$store.dispatch('removePrescription', this.data_to_be_deleted).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit("emitRefreshOrdonnance")

                    this.$refs.del_prescription.click()
                } else {
                    if (response.code == 403) {     // Can't delete due to the fact that it's already paid
                        this.error_message = "Impossible de supprimer !"
                    } else if (response.code == 409) {      // Permission denied
                        this.error_message = "Impossible de supprimer ! Ce médicament a été déjà payé"
                    } else if (response.code == 500) {      // An error occured
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.error_message = "Une erreur s'est produite !"
            })
        },

        deleteOrdonnance(selector) {
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) {     //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            
            this.del_loading = true;
            this.$store.dispatch('deleteOrdonnance', this.data_to_be_deleted).then((response) => {
                if (response.success) {
                    this.successToast("Suppression effectuée avec succès")
                    this.$emit("emitRefreshOrdonnance")

                    this.is_confirm = false
                    this.$refs.del_ordonnance.click();
                } else {
                    if (response.code == 403) {
                        this.permission_is_denied = true
                    } else if (response.code == 409) {
                        this.is_conflict = true
                    } 
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        async savePrescription() {
            this.clearError()
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return
            }
            this.selected_prescription.can_set_pac = this.can_set_pac
            this.selected_prescription.can_add_differential_computing = this.can_add_differential_computing.response
            this.save_loading = true
            this.$store.dispatch('updatePrescription', this.selected_prescription).then((response) => {
                if (response > 0) {
                    this.$refs.edit_ordonnance.click()
                    this.$emit("emitRefreshOrdonnance")

                    this.prescriptions = [{
                        medicament_stock: null,
                        medicament_libelle: "",
                        interne: false,
                        quantite: 1,
                        posologie: "",
                        conditionnement: "",
                        prix: 0,
                    }]
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    } else if (response === -3) {
                        this.is_paid = true
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        }
    }
}